module.exports = __webpack_public_path__ + "img/logo-white.43877379.svg";